module.exports = __webpack_public_path__ + "img/pasargad.ac91c6bf.png";